/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  FileMetaData,
  FileCaption,
  Button
} from '../'

import {
  getFileExtension,
  isViewableFileFormat
} from '../../utils'


export default class FileView extends React.PureComponent {
  static propTypes = {
    file: PropTypes.shape({
      asset: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    }).isRequired,
    download: PropTypes.bool,
    showMetaData: PropTypes.bool,
    displayEmail: PropTypes.func,
    noRotationButtons: PropTypes.bool
  }

  static defaultProps = {
    download: false,
    showMetaData: false,
    noRotationButtons: false,
    className: ''
  }

  static getDerivedStateFromProps(props, state) {
    // check if a new file has been selected to view and update state if that is the case
    if (props.file.url !== state.fileSrc && props.file.asset !== state.fileAsset) {
      return { fileSrc: props.file.url, fileAsset: props.file.asset, rotationDegrees: 0 }
    } else {
      return null
    }
  }

  state = {
    fileSrc: this.props.file.url,
    fileAsset: this.props.file.asset,
    rotationDegrees: 0
  }

  getNextRotationDegrees = (flip) => {
    if (flip) {
      return (this.state.rotationDegrees + 180) % 360
    } else {
      return (this.state.rotationDegrees + 90) % 360
    }
  }

  rotateImage = (flip) => {
    let newRotationDegrees = this.getNextRotationDegrees(flip)
    return newRotationDegrees === 0
      ? this.setState({ fileSrc: this.props.file.url, rotationDegrees: newRotationDegrees })
      : this.setState({
          fileSrc: `https://image.service.os.picsa.com/rotate?rotate=${newRotationDegrees}&accessKey=picsaos&url=${encodeURIComponent(this.props.file.url)}`,
          rotationDegrees: newRotationDegrees
        })
  }

  render() {
    let { file, download, showMetaData, displayEmail, noRotationButtons, className } = this.props
    return (
      <React.Fragment>
        {showMetaData &&
          <FileMetaData
            file={file.id}
            inverseColours={true}
            onSourceClick={displayEmail}
          />
        }
        <div className={`slds-file slds-m-around_x-large ${className}`}>
          <figure>
            <div className='slds-p-bottom_xx-large u-bg-color-white' style={{ position: 'relative' }}>
              {isViewableFileFormat(getFileExtension(file.asset)) &&
                <img src={this.state.fileSrc} alt={file.asset} style={{ width: '100%' }} />
              }
              {noRotationButtons === false &&
                <div style={{ position: 'absolute', bottom: '52px', right: '8px' }}>
                  <Button onClick={() => this.rotateImage(false)}>
                    Rotate 90&deg;
                  </Button>
                  <Button onClick={() => this.rotateImage(true)}>
                    Flip 180&deg;
                  </Button>
                </div>
              }
            </div>
            <FileCaption file={file} download={download} />
          </figure>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/file-view/index.js